import { tns } from 'tiny-slider/src/tiny-slider'

export default () => {

	const els = [...document.querySelectorAll('.testimonial')]
	els.map(el => {

		const carouselEl = el.querySelector('.testimonial-slider')
		if (!carouselEl) return null

		const carouselNav = el.querySelector('.testimonial__dots')


		// remove classes for setting pagewidth before carousel inits
		//carouselEl.classList.remove('grid')
		//carouselEl.classList.remove('page-width')

		return tns({
			container: carouselEl,
			items: 1,
			controls : false,
			controlsPosition: 'bottom',
			nav: true,
			navContainer: carouselNav,
			touch: true,
			mouseDrag: true,
			loop: true,
			autoplay: true,
			speed: 700,
			autoplayTimeout: 7000,
			autoplayButtonOutput: false,
			useLocalStorage: false,
		})
	})
}


